import { Component, inject, computed, HostListener, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NewsService } from '../../core/service/news.service';
import { NewsCardComponent } from './news-card/news-card.component';
import { SelectModule } from 'primeng/select';
import { DataViewModule } from 'primeng/dataview';
import { InputTextModule } from 'primeng/inputtext';
import { EntrepriseOptionService } from '../../core/service/entrepriseOption.service';
import { EntrepriseOptionsEnum } from '../../core/models/enums/entrepriseOption.enum';

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [CommonModule, NewsCardComponent, SelectModule, DataViewModule, InputTextModule],
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  providers: [ConfirmationService],
})
export class NewsComponent {
  constructor() {}

  #newsService = inject(NewsService);
  #entrepriseOptionsService = inject(EntrepriseOptionService);

  #listNewsQuery = this.#newsService.getListNews();
  #entrepriseOptionsQuery =
      this.#entrepriseOptionsService.listEntrepriseOptions();

  listNews = computed(() => this.#listNewsQuery.data() ?? []);
  searchText = signal<string>('');
  isSearching = signal<boolean>(false);
  searchResults = signal<any[] | null>(null);
  private _searchDebounceHandle: any = null;

  onSearchChange(value: string) {
    this.searchText.set(value);
    const v = (value ?? '').trim();
    if (this._searchDebounceHandle) {
      clearTimeout(this._searchDebounceHandle);
      this._searchDebounceHandle = null;
    }
    if (!v) {
      this.searchResults.set(null);
      this.isSearching.set(false);
      return;
    }
    this.isSearching.set(true);
    this._searchDebounceHandle = setTimeout(() => {
      this.#newsService.searchByTitle.mutate(
        { titre: v },
        {
          onSuccess: (res) => {
            this.searchResults.set(res ?? []);
            this.isSearching.set(false);
          },
          onError: () => {
            this.searchResults.set([]);
            this.isSearching.set(false);
          },
        }
      );
      this._searchDebounceHandle = null;
    }, 2000);
  }
  newsEnabled = computed(() => {
    let data = this.#entrepriseOptionsQuery.data() ?? [];
    let x =
      data.find((x: any) => x.key.toLowerCase() == EntrepriseOptionsEnum.NewsEnabled.toLowerCase())?.value ??
      false;
    return x.toString().toLowerCase() === 'true';
  });

  numberRows = signal<number>(6);

  ngOnInit() {
    this.numberRows.set(this.getNumberRows());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.numberRows.set(this.getNumberRows());
  }

  getNumberRows() {
    const width = window.innerWidth;
    if (width <= 576) {
      return 2;
    } else if (width > 576 && width <= 992) {
      return 4;
    }
    return 6;
  }

  ngOnDestroy() {
    if (this._searchDebounceHandle) {
      clearTimeout(this._searchDebounceHandle);
      this._searchDebounceHandle = null;
    }
  }
}
